var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDongle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.36936 2.36918C0.517104 2.52849 8.84987 11.3516 8.84987 11.3516V18.7165C8.84987 19.3905 9.51472 19.9419 10.3421 19.9419H13.3117C14.1243 19.9419 14.804 19.3905 14.804 18.7165V11.3394C14.804 11.3394 22.9151 2.73681 23.2992 2.34467C23.6834 1.95253 23.639 1.56039 23.639 1.56039C23.639 0.886406 22.9742 0.334961 22.1468 0.334961H1.49222C0.590977 0.334961 0 0.923169 0 1.56039C0 1.80548 0.0886464 2.09959 0.36936 2.36918Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDongle);
export default __webpack_public_path__ + "static/media/dongle.c812ded6e7a95472f08f43abafb2d790.svg";
export { ForwardRef as ReactComponent };